"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UlList = exports.OlList = exports.ListPlugin = void 0;

var _olList = _interopRequireDefault(require("./olList"));

var _ulList = _interopRequireDefault(require("./ulList"));

var _blocks = require("@canner/slate-constant/lib/blocks");

var _slateIconShared = require("@canner/slate-icon-shared");

var _commonNode = _interopRequireDefault(require("@canner/slate-editor-renderer/lib/commonNode"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ListPlugin = function ListPlugin(opt) {
  var options = Object.assign({
    olType: _blocks.OL_LIST,
    ulType: _blocks.UL_LIST,
    liType: _blocks.LIST_ITEM
  }, opt);
  return {
    renderNode: function renderNode(props) {
      if (props.node.type === options.ulType) return (0, _commonNode.default)("ul", _slateIconShared.nodeAttrs)(props);else if (props.node.type === options.olType) return (0, _commonNode.default)("ol", _slateIconShared.nodeAttrs)(props);else if (props.node.type === options.liType) return (0, _commonNode.default)("li", _slateIconShared.nodeAttrs)(props);
    }
  };
};

exports.ListPlugin = ListPlugin;
var OlList = _olList.default;
exports.OlList = OlList;
var UlList = _ulList.default;
exports.UlList = UlList;